import {forwardRef} from "react";
import {IconButton, Tabs, Tab} from "@mui/material";
import {ChevronLeft, ChevronRight} from "@mui/icons-material";
import {useTranslation} from "react-i18next";
import {DISTRIBUTOR_TABS} from "./distributor-navigation";

const ScrollButton = forwardRef(function ScrollButton({direction, disabled, onClick, className}, ref) {
    const {t} = useTranslation();
    return <IconButton ref={ref} className={className} disabled={disabled} onClick={onClick}
        aria-label={t(direction === "left" ? "WorkspaceTabsPrevious" : "WorkspaceTabsNext")}
        sx={{width: 40, flexShrink: 0, borderRadius: 1, visibility: disabled ? "hidden" : "visible"}}>
        {direction === "left" ? <ChevronLeft/> : <ChevronRight/>}
    </IconButton>;
});

export default function DistributorWorkspaceTabs({selected, onSelect, disabled}) {
    const {t} = useTranslation();
    // Reserve scroll-control space from first paint so a deep-linked last tab is fully revealed.
    return <Tabs value={selected} onChange={(_, value) => onSelect(value)} aria-label={t("WorkspaceTabs")}
        variant="scrollable" scrollButtons allowScrollButtonsMobile slots={{scrollButtons: ScrollButton}}
        sx={{"& .MuiTab-root.Mui-selected": {bgcolor: "action.selected"},
            "& .MuiTab-root.Mui-focusVisible, & .MuiIconButton-root.Mui-focusVisible": {
                outline: "2px solid", outlineColor: "primary.main", outlineOffset: -3}}}>
        {DISTRIBUTOR_TABS.map(({name, label, panel}) => <Tab key={name} value={name} label={t(label)}
            disabled={disabled} id={`distributor-tab-${panel}`} aria-controls={`distributor-tabpanel-${panel}`}/>)}
    </Tabs>;
}
